import { useQuery, useMutation, useQueryClient } from 'react-query';
import apiCalls from '../../utils/apiCalls';

export function useDeliveryDayMarketplace({ deliveryDayMarketplaceId, onSuccess }) {
  const { data, ...rest } = useQuery(
    'deliveryDayMarketplace',
    () =>
      apiCalls
        .getDeliveryDayMarketplaces({ deliveryDayMarketplaceId, includePredictedOrderItems: true })
        .then(({ data: { deliveryDayMarketplaces } }) => deliveryDayMarketplaces[0]),
    {
      onSuccess: (data) => {
        onSuccess(data);
      },
    }
  );
  return { deliveryDayMarketplace: data, ...rest };
}

export function useDeliveryDayMarketplaces(params) {
  const { data, ...rest } = useQuery('deliveryDayMarketplaces', () =>
    apiCalls.getDeliveryDayMarketplaces(params).then(({ data: { deliveryDayMarketplaces, totalCount } }) => ({
      deliveryDayMarketplaces,
      totalCount,
    }))
  );
  return { result: data, ...rest };
}

export function useDeliveryDayMarketplaceEdit(onSuccess) {
  const queryClient = useQueryClient();
  const { mutate, ...rest } = useMutation(
    ({ deliveryDayMarketplace }) => apiCalls.editDeliveryDayMarketplace({ deliveryDayMarketplace }),
    {
      onSuccess: (ddm) => {
        queryClient.invalidateQueries('deliveryDayMarketplaces');
        onSuccess(ddm);
      },
    }
  );
  return { editDeliveryDayMarketplace: mutate, ...rest };
}

export function useItems({ marketplaceId }) {
  const { data, ...rest } = useQuery(
    ['items', { marketplaceId }],
    () =>
      apiCalls.getItems({ marketplaceId }).then(({ data: { items, totalCount } }) => ({
        items,
        totalCount,
      })),
    { enabled: !!marketplaceId }
  );
  return { result: data, ...rest };
}
